(function () {
  'use strict';

  var loader = document.querySelector('[data-site-loader]');
  if (!loader) return;

  if (document.documentElement.classList.contains('shopify-design-mode')) {
    loader.remove();
    document.documentElement.classList.remove('is-loading');

    if (document.body) {
      document.body.classList.remove('is-site-loading');
    }

    return;
  }

  var percentageElement = loader.querySelector('[data-loader-number]');
  var progressBar = loader.querySelector('[data-loader-progress]');

  var sequence = ['00', '01', '05', '10', '30', '40', '50', '80', '90', '100'];

  var MINIMUM_TIME = 700;
  var MAXIMUM_TIME = 7000;
  var FINAL_HOLD = 180;

  var loaderFinished = false;
  var domContentLoadedReleased = false;
  var startTime = Date.now();
  document.body.style.overflowY = 'hidden';

  var progress = { value: 0 };
  var progressTween = null;

  var currentIndex = 0;
  var sequenceFinished = false;
  var assetsReady = false;

  var currentNumber;
  var nextNumber;


  function setupNumbers() {
    if (!percentageElement) return;

    percentageElement.innerHTML = '';

    currentNumber = document.createElement('span');
    nextNumber = document.createElement('span');

    currentNumber.className = 'loader-number-layer';
    nextNumber.className = 'loader-number-layer';

    currentNumber.textContent = sequence[0];
    nextNumber.textContent = sequence[1];

    percentageElement.appendChild(currentNumber);
    percentageElement.appendChild(nextNumber);

    gsap.set(currentNumber, {
      yPercent: 0
    });

    gsap.set(nextNumber, {
      yPercent: 100
    });
  }


  function renderProgress(value) {
    if (!progressBar) return;

    progressBar.style.width =
      Math.round(value) + '%';
  }


  function animateProgress(target, duration, ease) {
    if (progressTween) {
      progressTween.kill();
    }

    progressTween = gsap.to(progress, {
      value: target,
      duration: duration,
      ease: ease || 'power2.out',
      onUpdate: function () {
        renderProgress(progress.value);
      }
    });
  }


 function animateNextNumber(nextIndex, onComplete) {

  if (nextIndex >= sequence.length) {
    onComplete();
    return;
  }

  nextNumber.textContent = sequence[nextIndex];

  gsap.set(nextNumber, {
    yPercent: 100
  });

  gsap.set(currentNumber, {
    yPercent: 0
  });

  gsap.timeline({
    onComplete: function () {

      currentNumber.textContent =
        sequence[nextIndex];

      gsap.set(currentNumber, {
        yPercent: 0
      });

      gsap.set(nextNumber, {
        yPercent: 100
      });

      currentIndex = nextIndex;

      animateProgress(
        parseInt(sequence[nextIndex], 10),
        0.25,
        'power2.out'
      );

      onComplete();
    }
  })
  .to(nextNumber, {
    yPercent: 0,
    duration: 0.35,
    ease: 'power3.out'
  })
  .to(currentNumber, {
    yPercent: -100,
    duration: 0.35,
    ease: 'power3.out'
  }, '<');
}

  function playSequence() {

    if (
      sequenceFinished ||
      loaderFinished
    ) {
      return;
    }

    animateNextNumber(
      currentIndex + 1,
      function () {

        if (
          currentIndex <
          sequence.length - 1
        ) {

          gsap.delayedCall(
            0.2,
            function () {
              playSequence();
            }
          );

        } else {

          sequenceFinished = true;
          tryFinish();
        }
      }
    );
  }


  function waitForImages() {

    var images = Array.prototype.slice.call(
      document.images
    );

    if (!images.length) {
      return Promise.resolve();
    }

    return Promise.all(
      images.map(function (image) {

        if (
          image.complete &&
          image.naturalWidth > 0
        ) {
          return Promise.resolve();
        }

        if (
          image.complete &&
          image.naturalWidth === 0
        ) {
          return Promise.resolve();
        }

        return new Promise(function (resolve) {

          var done = false;

          function finish() {

            if (done) return;

            done = true;

            image.removeEventListener(
              'load',
              finish
            );

            image.removeEventListener(
              'error',
              finish
            );

            resolve();
          }

          image.addEventListener(
            'load',
            finish,
            { once: true }
          );

          image.addEventListener(
            'error',
            finish,
            { once: true }
          );

          setTimeout(
            finish,
            10000
          );
        });
      })
    );
  }


  function waitForVideos() {

    var videos = Array.prototype.slice.call(
      document.querySelectorAll('video')
    );

    if (!videos.length) {
      return Promise.resolve();
    }

    return Promise.all(
      videos.map(function (video) {

        if (video.readyState >= 3) {
          return Promise.resolve();
        }

        return new Promise(function (resolve) {

          var done = false;

          function finish() {

            if (done) return;

            done = true;

            video.removeEventListener(
              'canplaythrough',
              finish
            );

            video.removeEventListener(
              'loadeddata',
              finish
            );

            video.removeEventListener(
              'error',
              finish
            );

            resolve();
          }

          video.addEventListener(
            'canplaythrough',
            finish,
            { once: true }
          );

          video.addEventListener(
            'loadeddata',
            finish,
            { once: true }
          );

          video.addEventListener(
            'error',
            finish,
            { once: true }
          );

          setTimeout(
            finish,
            12000
          );
        });
      })
    );
  }


  function waitForFonts() {

    if (
      !document.fonts ||
      !document.fonts.ready
    ) {
      return Promise.resolve();
    }

    return document.fonts.ready.catch(
      function () {
        return Promise.resolve();
      }
    );
  }


  function waitForWindowLoad() {

    if (
      document.readyState === 'complete'
    ) {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {

      window.addEventListener(
        'load',
        resolve,
        { once: true }
      );
    });
  }


  function releaseDOMContentLoaded() {

    if (domContentLoadedReleased) {
      return;
    }

    domContentLoadedReleased = true;

    var event = new Event(
      'DOMContentLoaded',
      {
        bubbles: true,
        cancelable: false
      }
    );

    event.__siteLoaderSynthetic = true;

    document.dispatchEvent(event);
  }


  document.addEventListener(
    'DOMContentLoaded',
    function (event) {

      if (
        event.__siteLoaderSynthetic === true
      ) {
        return;
      }

      if (!domContentLoadedReleased) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }

    },
    true
  );


  function tryFinish() {

    if (
      !assetsReady ||
      !sequenceFinished ||
      loaderFinished
    ) {
      return;
    }

    completeLoader();
  }


  function completeLoader() {

    if (loaderFinished) {
      return;
    }

    loaderFinished = true;

    if (progressTween) {
      progressTween.kill();
    }

    animateProgress(
      100,
      0.25,
      'power3.out'
    );

    gsap.set(
      currentNumber,
      {
        yPercent: 0
      }
    );

    gsap.set(
      nextNumber,
      {
        yPercent: 100
      }
    );

    setTimeout(
      exitLoader,
      FINAL_HOLD + 250
    );
  }


  function exitLoader() {

    
    document.documentElement.classList.remove(
      'is-loading'
    );

    if (document.body) {
      document.body.classList.remove(
        'is-site-loading'
      );

        document.body.style.overflowY = 'auto';

    }

    releaseDOMContentLoaded();

    gsap.to(loader, {
      opacity: 0,
      duration: 0.6,
      ease: 'power3.inOut',
      onComplete: function () {

        if (
          loader &&
          loader.parentNode
        ) {
          loader.parentNode.removeChild(
            loader
          );
        }
      }
    });
  }


  var assetsPromise = Promise.all([
    waitForWindowLoad(),
    waitForImages(),
    waitForVideos(),
    waitForFonts()
  ]);


  setupNumbers();

  animateProgress(
    0,
    0,
    'none'
  );

  playSequence();


  assetsPromise.then(function () {

    assetsReady = true;

    var elapsed =
      Date.now() - startTime;

    var remaining =
      Math.max(
        0,
        MINIMUM_TIME - elapsed
      );

    setTimeout(
      function () {
        tryFinish();
      },
      remaining
    );
  });


  setTimeout(function () {

    if (loaderFinished) {
      return;
    }

    assetsReady = true;
    sequenceFinished = true;

    tryFinish();

  }, MAXIMUM_TIME);

})();